import React from "react"
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Row,
  Col,
  ListGroup,
  ListGroupItem
} from "reactstrap"
import { Link } from "react-router-dom"
import Breadcrumbs from "../../../components/@vuexy/breadCrumbs/BreadCrumb"
import "../../../assets/scss/pages/knowledge-base.scss"

class KBCategory extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Breadcrumbs
          breadCrumbTitle="Category"
          breadCrumbParent="Pages"
          breadCrumbParent2="Knowledge Base"
          breadCrumbActive="Category"
        />
        <Row>
          <Col sm="12">
            <p>
              petiole antimasquer nonenduring hoofish unbed anergic sweetwood
              ailsyte.
            </p>
          </Col>
          <Col lg="4" md="6" sm="12">
            <Card>
              <CardHeader>
                <CardTitle>Buying</CardTitle>
              </CardHeader>
              <CardBody className="knowledge-base-category">
                <ListGroup flush>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Cake icing gummi bears?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Jelly soufflé apple pie?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Soufflé apple pie ice cream cotton?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Powder wafer brownie?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Toffee donut dragée cotton candy?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Soufflé chupa chups chocolate bar?</Link>
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4" md="6" sm="12">
            <Card>
              <CardHeader>
                <CardTitle>Item Support</CardTitle>
              </CardHeader>
              <CardBody className="knowledge-base-category">
                <ListGroup flush>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Dessert halvah carrot cake sweet?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Jelly beans bonbon marshmallow?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Marzipan chocolate gummi bears bonbon powder?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Chupa chups lemon drops caramels?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Cake icing gummi bears?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Soufflé apple pie ice cream cotton?</Link>
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4" md="6" sm="12">
            <Card>
              <CardHeader>
                <CardTitle>Payments</CardTitle>
              </CardHeader>
              <CardBody className="knowledge-base-category">
                <ListGroup flush>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Oat cake lemon drops sweet sweet?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Cotton candy brownie ice cream wafer roll?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Chocolate bonbon cake sugar plum?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Cake fruitcake chupa chups?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Chupa chups lemon drops caramels?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Fruitcake bonbon dessert gingerbread powder?</Link>
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4" md="6" sm="12">
            <Card>
              <CardHeader>
                <CardTitle>Downloads</CardTitle>
              </CardHeader>
              <CardBody className="knowledge-base-category">
                <ListGroup flush>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Marshmallow jelly beans oat cake?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Cake ice cream jujubes cookie?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Sesame snaps tart cake pie chocolate?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Chocolate cake chocolate tootsi?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Caramels lemon drops tiramisu cake?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Brownie dessert gummies. Tiramisu bear claw apple?</Link>
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4" md="6" sm="12">
            <Card>
              <CardHeader>
                <CardTitle>Licenses</CardTitle>
              </CardHeader>
              <CardBody className="knowledge-base-category">
                <ListGroup flush>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Macaroon tootsie roll?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Cheesecake sweet soufflé jelly tiramisu chocolate?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Carrot cake topping tiramisu oat?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Ice cream soufflé marshmallow?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Dragée liquorice dragée jelly beans?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Lemon drops gingerbread chupa chups tiramisu?</Link>
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4" md="6" sm="12">
            <Card>
              <CardHeader>
                <CardTitle>Documents</CardTitle>
              </CardHeader>
              <CardBody className="knowledge-base-category">
                <ListGroup flush>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Brownie dessert gummies?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Cookie tiramisu lollipop?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Bonbon sugar plum jelly-o?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Ice cream soufflé marshmallow?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Halvah chupa chups chupa chups?</Link>
                  </ListGroupItem>
                  <ListGroupItem>
                   <Link to="/pages/knowledge-base/category/questions">Cheesecake sweet soufflé jelly tiramisu chocolate?</Link>
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}
export default KBCategory
